import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type {
  FetchKnowledgeBaseFailedPayload,
  FetchKnowledgeBasePayload,
  FetchKnowledgeBaseSucceededPayload,
  KnowledgeBaseState,
  SyncKnowledgeBasePayload,
} from './types';

export const initialState: KnowledgeBaseState = {
  items: [],
  isLoading: false,
  error: null,
  total: 0,
  isSyncingBlogs: false,
  isCustomSyncing: false,
};

export const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    fetchKnowledgeBaseRequested(state, _action: PayloadAction<FetchKnowledgeBasePayload>) {
      state.isLoading = true;
      state.error = null;
    },
    fetchKnowledgeBaseSucceeded(state, action: PayloadAction<FetchKnowledgeBaseSucceededPayload>) {
      state.items = action.payload.items;
      state.total = action.payload.total;
      state.isLoading = false;
      state.error = null;
    },
    fetchKnowledgeBaseFailed(state, action: PayloadAction<FetchKnowledgeBaseFailedPayload>) {
      state.isLoading = false;
      state.error = action.payload.message;
    },
    syncBlogsRequested(state, _action: PayloadAction<SyncKnowledgeBasePayload>) {
      state.isSyncingBlogs = true;
    },
    syncBlogsFinished(state) {
      state.isSyncingBlogs = false;
    },
    customSyncRequested(state, _action: PayloadAction<SyncKnowledgeBasePayload>) {
      state.isCustomSyncing = true;
    },
    customSyncFinished(state) {
      state.isCustomSyncing = false;
    },
    clearKnowledgeBase(state) {
      state.items = [];
      state.total = 0;
      state.isLoading = false;
      state.error = null;
      state.isSyncingBlogs = false;
      state.isCustomSyncing = false;
    },
  },
});

export const { actions: knowledgeBaseActions } = knowledgeBaseSlice;

export const useKnowledgeBaseSlice = () => {
  return { actions: knowledgeBaseSlice.actions };
};
